const language_key = {
  en: {
    'Template Name': 'Template Name',
    'Doc Template': 'Doc Template',
    'My Doc': 'My Doc',
    'Title': 'Title',
    'No': 'No',
    'Date': 'Date',
    'Select supplier': 'Select supplier',
    'seller': 'Seller',
    'buyer': 'Buyer',
    'Consignee': 'Consignee',
    'Currency': 'Currency',
    'Products': 'Products',
    'Change': 'Change',
    'Company Name': 'Company Name',
    'Contacts': 'Contacts',
    'Tel No': 'Tel No',
    'Email': 'Email',
    'Address': 'Address',
    'CNY-RMB': 'CNY-RMB',
    'USD-US Dollar': 'USD-US Dollar',
    'Product Code': 'Product Code',
    'Product Name': 'Product Name',
    'Package Specification': 'Package Specification',
    'Unit Price': 'Unit Price',
    'Total Pcs/Carton': 'Total Pcs/Carton',
    'Subtotal Amount': 'Subtotal Amount',
    'operation': 'operation',
    'Add': 'Add',
    'Delete': 'Delete',
    'Transportation': 'Transportation',
    'INCO TERM': 'INCO TERM',
    'Product quality level and quality descriptions': 'Product quality level and quality descriptions',
    'Payment Terms': 'Payment Terms',
    'Other Remarks': 'Other Remarks',
    'Total': 'Total',
    'Port of Loading': 'Port of Loading',
    'Shipment Date': 'Shipment Date',
    'Port of Destination': 'Port of Destination',
    'ETA': 'ETA',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'Submit': 'Submit',
    'Please Entry': 'Please Entry',
    'Submitted': 'Submitted',
    'Not submitted': 'Not submitted',
    'Buyer Confirmed': 'Buyer Confirmed',
    'NO': 'NO',
    'Type': 'Type',
    'Category': 'Category',
    'Seller': 'Seller',
    'Status': 'Status',
    'Reset': 'Reset',
    'Search': 'Search',
    'Update Time': 'Update Time',
    'Operation': 'Operation',
    'View': 'View',
    'Edit': 'Edit',
    'Download': 'Download',
    'Back': 'Back',
    'Buyer': 'Buyer',
    'Enter up to 50 characters': 'Enter up to 50 characters',
    'Enter up to 100 characters': 'Enter up to 100 characters',
    'Enter up to 200 characters': 'Enter up to 200 characters',
    'Input content must be at least 8 characters long': 'Input content must be at least 8 characters long',
    'Input content cannot exceed 21 characters': 'Input content cannot exceed 21 characters',
    'Only letters and numbers are allowed': '只允许使用字母和数字',
    'Please enter a valid email address': 'Please enter a valid email address',
    'Do you want to proceed with the deletion?': 'Do you want to proceed with the deletion?',
    'Nothing you searched for': 'Nothing you searched for',
    'Please Select Category': 'Please Select Category',
    'Company Code': 'Company Code',
    'Select': 'Select'
  },
  zh: {
    'Template Name': '模版名称',
    'Doc Template': '单据模版',
    'My Doc': '我的单据',
    'Title': '单据标题',
    'No': '单据编码',
    'Date': '日期',
    'Select supplier': '选择供应商',
    'Change': '变更供应商',
    'seller': '供应商',
    'buyer': '买家',
    'Consignee': '委托进口商',
    'Products': '商品',
    'Company Name': '公司名称',
    'Contacts': '联系人',
    'Tel No': '联系电话',
    'Email': '联系邮箱',
    'Address': '公司地址',
    'CNY-RMB': 'CNY-人民币',
    'USD-US Dollar': 'USD-美元',
    'Product Code': '商品编码',
    'Product Name': '商品名称',
    'Package Specification': '商品规格',
    'Unit Price': '单价',
    'Total Pcs/Carton': '商品总量',
    'Subtotal Amount': '金额小计',
    'operation': '操作',
    'Add': '新增',
    'Delete': '删除',
    'Transportation': '物流信息',
    'INCO TERM': '期望贸易方式',
    'Product quality level and quality descriptions': '产品等级及质量描述',
    'Payment Terms': '付款条件',
    'Other Remarks': '备注',
    'Total': '合计',
    'Port of Loading': '装运港/发货地',
    'Shipment Date': '装船日期',
    'Port of Destination': '目的港/目的地',
    'ETA': '预计到达日期',
    'Cancel': '取消',
    'Save': '保存草稿',
    'Submit': '提交',
    'Please Entry': '请输入',
    'Submitted': '已提交',
    'Not submitted': '未提交',
    'Buyer Confirmed': '供应商已确认',
    'NO': '单据编码',
    'Type': '单据类型',
    'Category': '所属品类',
    'Seller': '供应商编码/供应商名称',
    'Buyer': '买家编码/买家名称',
    'Status': '单据状态',
    'Reset': '重置',
    'Search': '搜索',
    'Update Time': '更新时间',
    'Operation': '操作',
    'View': '查看',
    'Edit': '继续编辑',
    'Download': '导出',
    'Back': '返回',
    'Enter up to 50 characters': '最多输入50个字符',
    'Enter up to 100 characters': '最多输入100个字符',
    'Enter up to 200 characters': '最多输入200个字符',
    'Input content must be at least 8 characters long': '输入内容长度必须至少8个字符',
    'Input content cannot exceed 21 characters': '输入内容不能超过21个字符',
    'Only letters and numbers are allowed': '只允许使用字母和数字',
    'Please enter a valid email address': '请输入有效的邮箱地址',
    'Do you want to proceed with the deletion?': '您想继续删除吗？',
    'Currency': '结算币种',
    'Nothing you searched for': '没有您搜索的内容',
    'Please Select Category': '所属品类',
    'Company Code': '公司编码',
    'Select': '选择'
  },
};

export default language_key;